import { render, staticRenderFns } from "./HeaderCardNormal.vue?vue&type=template&id=655d7980&scoped=true&"
import script from "./HeaderCardNormal.vue?vue&type=script&lang=js&"
export * from "./HeaderCardNormal.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCardNormal.vue?vue&type=style&index=0&id=655d7980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d7980",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})
